// Module
var code = "<div class=\"container page-content\"> <div class=\"row\"> <div class=\"col-lg-12\"> <div class=\"content-box-large\"> <div id=\"details\" ui-view=\"content\"></div> </div> </div> </div> </div> ";
// Exports
module.exports = code;